module.exports = "<label class=\"radio\" [class.radio--grouped]=\"grouped\" [class.radio--disabled]=\"disabled\" tabindex=\"0\">\r\n    <input [(ngModel)]=\"model\" [value]=\"value\" [name]=\"name\" [disabled]=\"disabled\" (change)=\"onChangeCallback(model)\"\r\n           class=\"radio__input\" type=\"radio\" role=\"radio\" tabindex=\"-1\">\r\n    <span class=\"radio__element\"></span>\r\n    <span class=\"radio__label\" *ngIf=\"label\">{{ label | translate }}</span>\r\n</label>"


//////////////////
// WEBPACK FOOTER
// ./src/components/radio/radio.component.html
// module id = 33
// module chunks = 0 1